export default "__VITE_PUBLIC_ASSET__d0736d59__"